import { SagaIterator } from 'redux-saga';


export function* rootResourceGovernanceSaga(): SagaIterator {
  // Here is where actions and stuff will go
}
